export default {
  data() {
    return {
      cardsList: [
        {
          id: 'communication',
          title: 'Коммуникации и\u00A0совместная работа',
          productsList: [
            { name: 'Чаты', href: '/products/messenger/' },
            { name: 'Встречи', href: '/products/meetings/' },
            { name: 'Доски', href: '/products/boards/' },
            { name: 'Оборудование', href: '/products/software-and-equipment/' },
          ],
          img: 'main-product-1',
        },
        {
          id: 'education',
          title: 'Обучение и\u00A0проведение мероприятий',
          productsList: [
            { name: 'Вебинары', href: '/products/webinar/' },
            { name: 'Курсы', href: '/products/westudy/' },
            { name: 'Формы', href: '/products/forms/' },
            { name: 'COMDI', href: '/products/comdi/' },
          ],
          img: 'main-product-2',
        },
      ],
    }
  },
}
